var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"magnifier"},[_c('div',{staticClass:"magnifier-inner"},[_c('div',{staticClass:"small-box",attrs:{"data-title":"大图"},on:{"mouseover":_vm.handOver,"mousemove":_vm.handMove,"mouseout":_vm.handOut}},[_c('img',{staticClass:"smallPic",attrs:{"src":`${_vm.src}?x-oss-process=image/resize,l_836`}}),(!_vm.vuex_h5)?_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.showMask),expression:"showMask"}],staticClass:"magnifier-zoom",style:({
                    background: _vm.configs.maskColor,
                    height: _vm.configs.maskWidth + 'px',
                    width: _vm.configs.maskHeight + 'px',
                    opacity: _vm.configs.maskOpacity,
                    transform: _vm.transformMask,
                }),attrs:{"data-title":"大图放大遮罩"}}):_vm._e()]),(!_vm.vuex_h5)?_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.showMagnifier),expression:"showMagnifier"}],staticClass:"magnifier-layer",style:({
                width: _vm.configs.width + 'px',
                height: _vm.configs.height + 'px',
                left: _vm.configs.width + 20 + 'px',
            }),attrs:{"data-title":"大图局部放大器"}},[_c('div',{staticClass:"big-box",style:({
                    width: _vm.bigWidth + 'px',
                    height: _vm.bigHeight + 'px',
                    left: _vm.moveLeft,
                    top: _vm.moveTop,
                })},[_c('div',{staticClass:"big-box-img",style:({
                        width: _vm.bigWidth - 2 + 'px',
                        height: _vm.bigHeight - 2 + 'px',
                    })},[_c('img',{style:({
                            maxWidth: _vm.bigWidth - 2 + 'px',
                            maxHeight: _vm.bigHeight - 2 + 'px',
                        }),attrs:{"src":_vm.bigSrc}})])])]):_vm._e()])])
}
var staticRenderFns = []

export { render, staticRenderFns }